import { CUSTOM_VIEW_GROUPS } from 'src/graphql/entities/custom-view/constants';
import {
  CustomViewAttribute,
  UIType,
} from 'src/graphql/entities/custom-view/custom-view.types';
import {
  ProjectAttribute,
  ProjectAttributeAccessors,
  ProjectAttributeType,
} from './constants';

export const projectAttributeConfigList: CustomViewAttribute<ProjectAttributeType>[] = [
  {
    attribute: ProjectAttribute.siteClientSegment,
    attributeLabel: 'Client Segment',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Site,
    default: true,
  },
  {
    attribute: ProjectAttribute.siteName,
    attributeLabel: 'Site Name',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Site,
    default: true,
  },
  {
    attribute: ProjectAttribute.name,
    attributeLabel: 'Project Name',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Project,
    default: true,
  },
  {
    attribute: ProjectAttribute.stage,
    attributeLabel: 'Project Stage',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Project,
    default: true,
  },
  {
    attribute: ProjectAttribute.estSigningDate,
    attributeLabel: 'Signing Date',
    uiType: UIType.Date,
    group: CUSTOM_VIEW_GROUPS.Project,
    default: true,
  },
  {
    attribute: ProjectAttribute.estDay1,
    attributeLabel: 'Estimated Day1',
    uiType: UIType.Date,
    group: CUSTOM_VIEW_GROUPS.Project,
    default: true,
  },
  {
    attribute: ProjectAttribute.day1StartDate,
    attributeLabel: 'Day1 Start Date',
    uiType: UIType.Date,
    group: CUSTOM_VIEW_GROUPS.Project,
    default: true,
  },
  {
    attribute: ProjectAttribute.cppExpDate,
    attributeLabel: 'CPP Expiration',
    uiType: UIType.Date,
    group: CUSTOM_VIEW_GROUPS.Site,
    default: true,
  },

  {
    attribute: ProjectAttribute.warrantyExpiration,
    attributeLabel: 'Warranty Expiration',
    uiType: UIType.Date,
    group: CUSTOM_VIEW_GROUPS.Project,
    default: true,
  },
  {
    attribute: ProjectAttribute.clientActivatedMembership,
    attributeLabel: 'Service Level',
    uiType: UIType.Custom,
    group: CUSTOM_VIEW_GROUPS.Site,
    default: true,
  },
  {
    attribute: ProjectAttribute.projectManager,
    attributeLabel: 'Project Manager',
    uiType: UIType.Avatar,
    group: CUSTOM_VIEW_GROUPS.Project,
    default: true,
  },
  {
    attribute: ProjectAttribute.createdAt,
    attributeLabel: 'Created At',
    uiType: UIType.Date,
    group: CUSTOM_VIEW_GROUPS.Project,
    default: true,
  },
  {
    attribute: ProjectAttribute.updatedAt,
    attributeLabel: 'Updated At',
    uiType: UIType.Date,
    group: CUSTOM_VIEW_GROUPS.Project,
    default: true,
  },
  {
    attribute: ProjectAttribute.id,
    attributeLabel: 'Project ID',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Project,
  },
  {
    attribute: ProjectAttribute.isPrimary,
    attributeLabel: 'Primary',
    uiType: UIType.Boolean,
    group: CUSTOM_VIEW_GROUPS.Project,
  },
  {
    attribute: ProjectAttribute.partnerName,
    attributeLabel: 'Partner Name',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Partner,
  },
  {
    attribute: ProjectAttribute.siteId,
    attributeLabel: 'Site ID',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Site,
  },

  {
    attribute: ProjectAttribute.siteAddress,
    attributeLabel: 'Address',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Site,
  },
  {
    attribute: ProjectAttribute.siteCity,
    attributeLabel: 'City',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Site,
  },
  {
    attribute: ProjectAttribute.siteZip,
    attributeLabel: 'Zip/Postal Code',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Site,
  },
  {
    attribute: ProjectAttribute.siteChargifySubId,
    attributeLabel: 'Subscription ID',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Site,
  },
  {
    attribute: ProjectAttribute.siteTOS,
    attributeLabel: 'TOS',
    uiType: UIType.Boolean,
    group: CUSTOM_VIEW_GROUPS.Site,
  },
  {
    attribute: ProjectAttribute.siteMembershipRegistered,
    attributeLabel: 'Membership Registered',
    uiType: UIType.Boolean,
    group: CUSTOM_VIEW_GROUPS.Site,
  },
  {
    attribute: ProjectAttribute.ownerName,
    attributeLabel: 'Account Manager',
    uiType: UIType.Avatar,
    group: CUSTOM_VIEW_GROUPS.Site,
  },
  {
    attribute: ProjectAttribute.siteCreatedAt,
    attributeLabel: 'Site Created At',
    uiType: UIType.Date,
    group: CUSTOM_VIEW_GROUPS.Site,
  },
  {
    attribute: ProjectAttribute.siteUpdatedAt,
    attributeLabel: 'Site Updated At',
    uiType: UIType.Date,
    group: CUSTOM_VIEW_GROUPS.Site,
  },
  {
    attribute: ProjectAttribute.clientName,
    attributeLabel: 'Client Name',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Site,
  },
  {
    attribute: ProjectAttribute.clientPhone,
    attributeLabel: 'Client Phone',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Site,
  },
  {
    attribute: ProjectAttribute.clientEmail,
    attributeLabel: 'Client Email',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Site,
  },
  {
    attribute: ProjectAttribute.businessName,
    attributeLabel: 'Business Name',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Site,
  },
].map((i) => ({
  ...i,
  accessor: ProjectAttributeAccessors[i.attribute].display,
  sortingKey: ProjectAttributeAccessors[i.attribute].sort,
  sortingAggFunction: ProjectAttributeAccessors[i.attribute].aggFunction,
}));

export const projectAttributeConfigMap = new Map(
  projectAttributeConfigList.map((i) => [i.attribute, i]),
);
